<template>
  <div v-if="howItWorks">
    <banner-part
      :banner-heading="_T_DB(howItWorks, 'banner_heading')"
      :banner-text="_T_DB(howItWorks, 'banner_text')"
      :banner-image="howItWorks.banner_image"
    />
    <content-part
      :content-heading="_T_DB(howItWorks, 'content_heading')"
      :content-text="_T_DB(howItWorks, 'content')"
      :content-image="howItWorks.content_image"
    />

    <how-it-works-part
      :content-heading="_T_DB(howItWorks, 'additional_heading')"
      :content-text="_T_DB(howItWorks, 'additional_content')"
      :content-image="howItWorks.additional_image"
    />
    <values-part :blocks="howItWorks.extra_blocks" />
  </div>
</template>

<script>
import BannerPart from './components/BannerPart'
import ContentPart from './components/ContentPart'
import ValuesPart from './components/ValuesPart'
import HowItWorksPart from './components/HowItWorksPart'
import { mapGetters } from 'vuex'

export default {
  name: 'StaticHowItWorks',
  components: {
    BannerPart,
    ContentPart,
    ValuesPart,
    HowItWorksPart,
  },
  computed: {
    ...mapGetters(['_T_DB', 'all_static_pages']),
    howItWorks() {
      if (this.all_static_pages) {
        return this.all_static_pages.find(
          page => page.type === 'regular' && page.slug === 'how-it-works'
        )
      }
      return {}
    },
  },
}
</script>

<style></style>
